import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import {
  Encrypted,
  DBInstanceID,
  DBEngine,
  LicenseModel,
  SnapshotType,
  Storage,
  Port,
  MasterUsername,
  IAMDBAuthentication,
} from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataField/MetaGridFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

export const RdsSnapshotMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields />
      {DBInstanceID(resource)}
      {DBEngine(resource)}
      {LicenseModel(resource)}
      {SnapshotType(resource)}
      {Storage(resource)}
      {Encrypted(insight)}
      {Port(resource)}
      {MasterUsername(resource)}
      {IAMDBAuthentication(resource)}
    </Grid>
  );
};
